import React from "react";
import Header from "../../headerone/Main";
import Bredcom from "../../Bredcom/Main";
import BlogOne from "../../Blogdetails/BlogOne";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom
          title="Home"
          subtitle="How to Choose the Right Pharmacy College After 12th"
        />
        <BlogOne />
      </section>
    </>
  );
}

export default Main;
